import ApplyBasicDivision from "./ApplyBasicDivision/ApplyBasicDivision";
import classes from "./TeamsHeader.module.css"
import { useSelector } from "react-redux";
import VideoPopup from "./VideoPopup";
import infoIcon from '../../../../../assests/learning-tracking/teams/info.png'
import { submissionStatusTextEnum } from "../../../../../models/SubmissionStatusEnum";

const TeamsHeader = ({
    setPopup,
    setLoading,
    lessonMode,
    deleteTeam,
    fetchTeams,
    participantsData,
    setDisplayLastChange,
    setSearchTerm,
    videoPopup,
    setVideoPopup,
    setAnableBasicDivisionButton,
    anableBasicDivisionButton,
    searchTerm }) => {

    const { texts } = useSelector(state => state.translate);
    const uiData = useSelector((state) => state.general.uiData);

    function hasUsersInTeams() {
        if (Object.values(participantsData.teams).length && Object.values(participantsData.teams).every(team => !team.users.length)) {
            return false
        }
        else
            if (Object.values(participantsData.teams).length && Object.values(participantsData.teams).findIndex(team => team.submissionStatus && team.submissionStatus != submissionStatusTextEnum.finalScored) != -1)
                return true
            else
                return false
    }

    return (
        <>
            <div className={classes.Header}>
                <div className={classes.Note}>
                    <div className={classes.TitleNote}>
                        <div>{lessonMode ? texts.titleLessonDivision : texts.titleBasicDivision}</div>
                        {!lessonMode && uiData.showTeamVideo && <img className={classes.InfoIcon} src={infoIcon} onClick={() => setVideoPopup(true)} />}
                    </div>
                    <div className={classes.Note}>{lessonMode ? texts.changeToPrivareOrTeamWork : texts.UseBasicDivisionAsTemplate} </div>

                </div>
                <div className={classes.SearchInputWrapper}>
                    <input type='text' placeholder={texts.findStudent} className={classes.SearchInput} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                    <div className={classes.SearchIcon}></div>
                </div>
            </div>
            <div className={classes.ActionBtnWarrper} >
                {lessonMode && <div className={`${classes.DeleteTeams} ${!hasUsersInTeams() && classes.DisableBtn}`} onClick={deleteTeam}>{texts.changeToPersonalWork}</div>}
                <ApplyBasicDivision
                    setPopup={setPopup}
                    setLoading={setLoading}
                    lessonMode={lessonMode}
                    fetchTeams={fetchTeams}
                    teams={participantsData.teams}
                    users={participantsData.participantsNotInTeams}
                    anableBasicDivisionButton={anableBasicDivisionButton}
                    setAnableBasicDivisionButton={setAnableBasicDivisionButton}
                    setDisplayLastChange={setDisplayLastChange}
                    hasUsersInTeams={hasUsersInTeams}>
                </ApplyBasicDivision>

            </div>
            {uiData.showTeamVideo && !lessonMode && videoPopup && <VideoPopup setVideoPopup={setVideoPopup}></VideoPopup>}

        </>
    )


}
export default TeamsHeader